var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: {
          subtitle:
            "Manage discrete and continuous station categories across the system.",
        },
      }),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: { dark: "", grow: "", centered: "" },
          model: {
            value: _vm.model,
            callback: function ($$v) {
              _vm.model = $$v
            },
            expression: "model",
          },
        },
        [
          _c("v-tabs-slider"),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { href: "#tab-1" } },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("assignment")]),
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AdministrationStationCategoryManage.DiscreteSampleStationCategory"
                  )
                ) + "\n    "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { href: "#tab-2" } },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("mdi-clock")]),
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "AdministrationStationCategoryManage.ContinuousDataStationCategory"
                  )
                ) + "\n    "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.model,
            callback: function ($$v) {
              _vm.model = $$v
            },
            expression: "model",
          },
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "tab-1" } },
            [_c("AdministrationStationDiscreteCategory")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "tab-2" } },
            [_c("AdministrationStationContinuousCategory")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }